import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B0F17] flex flex-col items-center justify-center gap-5 px-5 text-center">
      <XCircle className="w-14 h-14 text-amber-400" />
      <p className="text-xl font-semibold text-white">Checkout cancelled</p>
      <p className="text-slate-400 text-sm max-w-sm">No charge was made. Your results are still saved — you can unlock them anytime.</p>
      <button
        data-testid="back-to-history-button"
        onClick={() => navigate("/history")}
        className="mt-2 px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-500 to-indigo-500 text-white font-semibold hover:shadow-[0_0_30px_rgba(6,182,212,0.4)] transition-all"
      >
        Back to my results
      </button>
    </div>
  );
};
